module.exports = __webpack_public_path__ + "static/img/bp1.97ad385.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bp1.png
// module id = hnV2
// module chunks = 1